import { DateTime } from 'luxon'

import { FeedbackTypeResponseDTO } from '@/core/api/dtos/response/song/feedbackType'
import { FeedbackType } from '@/core/api/entities/song/feedbackType'

export class FeedbackTypeMapper {
	static toEntity(data: FeedbackTypeResponseDTO): FeedbackType {
		return new FeedbackType({
			id: data.id,
			key: data.key,
			name: data.name,
			titleTranslations: data.titleTranslations,
			isNegative: data.is_negative,
			shouldList: data.should_list,
			active: data.active,
			createdAt: DateTime.fromISO(data.created_at),
			updatedAt: DateTime.fromISO(data.updated_at),
		})
	}

	static toEntities(data: FeedbackTypeResponseDTO[]): FeedbackType[] {
		return data.map((item) => this.toEntity(item))
	}
}
